import React from 'react';
import "../Mani/Mani.scss";

const Mani = () => {
  return (
    <div className="Maniparent parent">
      <div className="Mani-cont container">
        <h1 className="mani-heading">जनकार्य अहवाल  </h1> {/* Centered Heading */}
        
        <section className="flipbook-section">
          <div className="iframe-container">
            {/* Overlay div to cover the logo */}
            {/* <div className="logo-overlay"></div>  */}

            <iframe
              src="https://online.pubhtml5.com/xlwqy/lqdo/"
              title="Manifesto View"
              allowFullScreen
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Mani;
